import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ChatContextValue = {
  bucket: string;
  scope: string;
  collections: string[];
};

const initialState: ChatContextValue = {
  bucket: '',
  scope: '',
  collections: [],
};

export type ChatContextInit = {
  value?: Partial<ChatContextValue> | null;
};

export const chatContextSliceName = 'chatContext';

export function extractMax4Collections(collections: string[] | undefined) {
  if (!collections) {
    return [];
  }
  if (collections.length > 4) {
    return [...collections.slice(0, 3), collections[collections.length - 1]];
  }
  return collections;
}

export const chatContextSlice = createSlice({
  name: chatContextSliceName,
  initialState,
  reducers: {
    initializeChatContext(state, action: PayloadAction<ChatContextInit>) {
      state.bucket = action.payload.value?.bucket || '';
      state.scope = action.payload.value?.scope || '';
      state.collections = extractMax4Collections(action.payload.value?.collections);
    },
    updateChatContext(state, action: PayloadAction<Partial<ChatContextValue>>) {
      const { bucket, scope, collections } = action.payload;
      if (bucket) {
        state.bucket = bucket;
      }
      if (scope || scope === '') {
        state.scope = scope;
      }
      if (collections) {
        if (collections.length === 0 || (collections.length === 1 && collections[0] === '')) {
          state.collections.length = 0;
        } else if (collections.length > state.collections.length) {
          state.collections = extractMax4Collections(collections);
        } else {
          state.collections.length = 0;
          state.collections = extractMax4Collections(collections);
        }
      }
    },
    resetChatContext(state, action: PayloadAction<ChatContextValue | undefined>) {
      if (action.payload) {
        state.bucket = action.payload.bucket || '';
        state.scope = action.payload.scope || '';
        state.collections = action.payload.collections || [];
      } else {
        state.bucket = '';
        state.scope = '';
        state.collections = [];
      }
    },
  },
});

export const { initializeChatContext, updateChatContext, resetChatContext } = chatContextSlice.actions;

export default chatContextSlice.reducer;
